import { CircularProgress } from '@material-ui/core';
import { useObserver } from 'mobx-react';
import { RequestStatus } from 'mobx-store';
import React, { useEffect } from 'react';
interface StateFullContainerProps {
    state: RequestStatus;
    children: JSX.Element;
}
const StateFullContainer: React.FC<StateFullContainerProps> = (props: StateFullContainerProps) => {
    const {
        state,
        children
    } = props;

    if (state === RequestStatus.LOADING) {
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <CircularProgress color="primary" />
            </div>
        );
    }
    if(state === RequestStatus.FAILED) {
        return <h1 style={{color: 'red'}}>Something went wrong</h1>
    }
    if(state === RequestStatus.SUCCESS) {
        return (children);
    }
    return null;
}
export default StateFullContainer;